import { Accounting } from "../../gateway/Accounting/Accounting";
import { Company } from "../../gateway/Company/Company";
import { Events } from "./Events/Events";

export class CompanyStatusChange {
    Accounting = new Accounting();
    Company = new Company();
    Events = new Events();
    callback = () => {};
    constructor({ DSNDialogService, $mdDialog, accountingId }) {
        this.DSNDialogService = DSNDialogService;
        this.$mdDialog = $mdDialog;
        this.accountingId = accountingId;
    }

    async execute({ $event, company = { _id, status } }, callback) {
        this.callback = callback;
        this.accounting = await this.Accounting.getById(this.accountingId);
        if (company.status == "ATIVO") {
            this.showDialogInactivateCompany(company, $event);
        } else if (
            company.status == "INATIVO" ||
            company.status == "CHURN" ||
            !company.status
        ) {
            const maxCompanies = this.accounting?.plan?.countCompany;
            const companiesList = await this.Company.getByAccId({
                accountingId: this.accountingId,
                filters: {
                    status: "ATIVO"
                }
            });
            const companies = this.filterCompanies(companiesList);
            const countCompanies = companies?.length;
            const countText = `${countCompanies}/${maxCompanies}`;
            if (countCompanies < maxCompanies) {
                this.showDialogActivateCompany(company, countText, $event);
            } else {
                this.showDialogPlanLimit(company, countText, $event);
            }
        }
    }

    filterCompanies(companies) {
        return companies.filter(
            (company) =>
                company._id !== "EMPRESA_MODELO" &&
                company.analytics?.fromAccounting === undefined
        );
    }

    showDialogInactivateCompany(company, $event) {
        this.DSNDialogService.confirmation({
            targetEvent: $event,
            locals: {
                destructive: true,
                title: "Desativar Empresa",
                description:
                    "Ao desativar uma empresa, ela perderá o acesso às funcionalidades do Nucont. As empresas precisam muito de você. Tem certeza que deseja desativar? ",
                actions: {
                    confirm: {
                        label: "Desativar",
                        action: () => {
                            this.callback({ status: "INATIVO" });
                            this._onActiveCompany(company, "INATIVO");
                            this.Events.send("Empresa.Desativar");
                            this.$mdDialog.cancel();
                        }
                    },
                    cancel: {
                        label: "Cancelar",
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    }
                }
            },
            after: {
                hide: (answer) => {},
                cancel: () => {}
            }
        });
    }

    async _onActiveCompany(company, status) {
        company.status = status;
        await this.Company.updateFields(this.accountingId, company._id, {
            status,
            accountingId: this.accountingId
        });
    }

    showDialogActivateCompany(company, countText, $event) {
        this.DSNDialogService.confirmation({
            targetEvent: $event,
            locals: {
                destructive: false,
                title: "Ativar Empresa",
                description: `Ao ativar esta empresa, você habilitará todas as funcionalidades da plataforma Nucont. No momento, existem <strong>${countText} empresas ativas</strong> no seu plano atual.</br></br>Gostaria de ativar e conectar esta empresa agora?`,
                actions: {
                    confirm: {
                        label: "Ativar Empresa",
                        action: () => {
                            this.callback({ status: "ATIVO" });
                            this._onActiveCompany(company, "ATIVO");
                            this.Events.send("Empresa.Ativar");
                            this.$mdDialog.cancel();
                        }
                    },
                    cancel: {
                        label: "Talvez depois",
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    }
                }
            },
            after: {
                hide: (answer) => {},
                cancel: () => {}
            }
        });
    }

    showDialogPlanLimit(company, countText, $event) {
        this.DSNDialogService.confirmation({
            targetEvent: $event,
            locals: {
                destructive: false,
                title: "Limite de empresas ativas alcançado",
                description: `Atualmente existem<b> ${countText} </b>empresas ativas no seu plano atual. Para ativar esta empresa, será necessário <b>aumentar o seu plano</b>. Se quiser, seu Consultor de Sucesso entrará em contato com você para fazer o upgrade!`,
                actions: {
                    confirm: {
                        label: "Clique para informar seu Consultor de Sucesso",
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    },
                    cancel: {
                        label: "Talvez depois",
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    }
                }
            },
            after: {
                hide: (answer) => {},
                cancel: () => {}
            }
        });
    }
}
